<div *ngIf="task.message.attachments.length > 0" class="attachments">
  <ng-container *ngFor="let attachment of task.message.attachments">
    <ng-container [ngSwitch]="attachment.mime_type">
      <div
        *ngSwitchCase="'image'"
        class="attachment image"
        [matTooltip]="attachment.name"
        (click)="viewPicture(attachment.message_index)">
        <img [appJwtSrc]="baseUrl + attachment.message_index" />
      </div>

      <div *ngSwitchCase="'video'" class="attachment video">
        <video>
          <source [appJwtSrc]="baseUrl + attachment.message_index" />
        </video>
        <div
          [matTooltip]="attachment.name"
          (click)="viewMedia(attachment.message_index, attachment.mime_type)"
          class="play">
          <ion-icon name="play-circle" color="primary"></ion-icon>
        </div>
      </div>

      <div
        *ngSwitchCase="'audio'"
        class="attachment"
        [matTooltip]="attachment.name"
        (click)="viewMedia(attachment.message_index, attachment.mime_type)">
        <ion-icon name="musical-notes" color="primary"></ion-icon>
        <div class="infos">
          <span class="extension">{{ attachment.name | fileExtension }}</span>
        </div>
      </div>

      <div
        *ngSwitchCase="'file'"
        class="attachment"
        [matTooltip]="('attachments/File' | translate) + ' ' + attachment.name"
        (click)="downloadFile(attachment)">
        <ion-icon name="attach" color="primary"></ion-icon>
        <div class="infos">
          <span class="extension">{{ attachment.name | fileExtension }}</span
          ><span *ngIf="attachment.size">
            -
            <span [innerHTML]="attachment.size | bytesPrefix"></span>
          </span>
        </div>
      </div>

      <!-- type link and shopProductInfo are processed in TaskMessageComponent -->
    </ng-container>
  </ng-container>
</div>
